const $ = window.jQuery;

class ActionBox {
  constructor() {
    this.elem = $('.action-box');
    if (this.elem.length) {
      this.animation();
    }
  }

  animation() {
    this.elem.one('inview', (event, isInView) => {
      if (isInView) {
        this.elem.addClass('action-box--inview');
      }
    });
  }
}

export default ActionBox;
